import { AddressModel } from './address.model';

export class IndividualAddressModel extends AddressModel {

  cxa_key: string = undefined;
  cxa_cst_key: string = undefined;
  cxa_on_hold_flag: boolean = undefined;
  cxa_primary: boolean = undefined;
  cxa_billing: boolean = undefined;
  cxa_mailing_label: string = undefined;
  cxa_adt_key: string = undefined;
  adt_code: string = undefined;

  constructor(source?: any) {
    super(source);

    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'cxa_key':
            case 'cxa_cst_key':
            case 'cxa_on_hold_flag':
            case 'cxa_primary':
            case 'cxa_billing':
            case 'cxa_mailing_label':
            case 'cxa_adt_key':
            case 'adt_code':
              this[key] = source[key];
          }
        }
      }
    }
  }
}
